import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import Loader from "../../epg/components/Loader";

const SetupButton = ({ text, onPress, focusKey, isLoading = false }) => {
    const { ref, focused } = useFocusable({
        focusKey: focusKey,
        onEnterPress: onPress,
    });

    return (
        <div className="setup-button-wrapper" ref={ref}>
            <button
                className={`setup-button ${focused ? "focused" : ""}`}
                onClick={onPress}
                tabIndex={-1}
                aria-label={text}
                disabled={isLoading}
            >
                {isLoading && <Loader textColor="#000" />}
                {!isLoading && text}
            </button>
        </div>
    );
};

export default SetupButton;
